import { takeEvery } from 'redux-saga'
import { put, call, select } from 'redux-saga/effects'
import { CREATE_MULTI_IMAGER_LENS } from 'actions/multiImagerActionTypes'
import { cameraModelsSelector } from 'selectors'
import { addMultiImagerLensAction } from 'actions/multiImagerActions'
import { updateCameraAction } from 'actions/cameraActions'
import { notifyHoneybadgerAction } from 'actions/applicationActions'

export function * createMultiImagerLens(action) {
  try {
    const { cameraModels } = yield select(cameraModelsSelector)
    const { lens: { id, lensId } } = action
    const lensModel = cameraModels.find(m => m.id === lensId)

    yield put.resolve(addMultiImagerLensAction(action.lens))
    yield put(updateCameraAction('model', { model: lensModel, aov: lensModel.aovs.length > 0 ? lensModel.aovs[0] : null }, id))
  } catch (err) {
    yield put(notifyHoneybadgerAction(err, action))
  }
}

/** Watch for create multi imager lens action, then call function */
export function * watchCreateMultiImagerLens() {
  yield * takeEvery(CREATE_MULTI_IMAGER_LENS, createMultiImagerLens)
}



// WEBPACK FOOTER //
// ./src/sagas/createMultiImagerLensSaga.js